export default "__VITE_ASSET__CHsQEvb8__"